<template>
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/21101fb9fa9f550178ff5ae6" -->
    <div class="main">
      <!-- 双击高压锅 -->
      <div class="left left-overflow">
        <div class="left-content slip_out_animation">
          <div class="type-title">公司简介</div>
          <div class="video-content">
            <video
              controls
              src="https://player.alicdn.com/video/editor.mp4"
            ></video>
          </div>
        </div>
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>生产线实时数据</div>
          </div>
          <div class="item-info">
            <div>班次：白班</div>
            <div>名称：感染性废物</div>
            <div>处理量：1.2吨</div>
          </div>
        </div>
      </div>
      <div class="right right-overflow" :style="'height:'+screenHeight"> 
        <div class="slip_in_animation">
          <div class="right-content slip_in_animation">
            <div class="type-title">
              <div>CRT电视、电脑拆解线模型</div>
            </div>
            <div class="item-info">
              <iframe
                src="https://www.thingjs.com/s/21101fb9fa9f550178ff5ae6"
                frameborder="0"
                class="modelIframe"
              ></iframe>
            </div>
          </div>
          <div class="right-content slip_in_animation">
            <div class="type-title">
              <div>拆解线介绍</div>
            </div>
            <div class="item-info">
              <div>处理能力：90万台/a</div>
              <div>处理节拍：400台/h</div>
              <div>最大拆解尺寸：1000mm*600mm*700mm</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 双击破碎机 -->
      <!-- <div class="right right-overflow" :style="'height:'+screenHeight"> 
        <div class="right-content slip_in_animation">
          <div class="type-title">
            <div>CRT电视、电脑拆解线模型</div>
          </div>
          <div class="item-info">
            <iframe
              src="https://www.thingjs.com/s/21101fb9fa9f550178ff5ae6"
              frameborder="0"
              class="modelIframe"
            ></iframe>
          </div>
        </div>
        <div class="right-content slip_in_animation">
          <div class="type-title">
            <div>拆解线介绍</div>
          </div>
          <div class="item-info">
            <div>处理能力：90万台/a</div>
            <div>处理节拍：400台/h</div>
            <div>最大拆解尺寸：1000mm*600mm*700mm</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
    };
  },
  mounted() {},
  methods: {},
};
</script>
  <style scoped lang="scss">
.modelIframe {
  width: 100%;
  min-height: 19.5vh;
}
.main .left,
.main .right {
  width: 21.3vw;
  height: 75vh;
  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
  .left-content {
    box-sizing: border-box;
    padding: 20px;
    color: #fff;
    height: auto;
    .video-content {
      width: 100%;
    }
    .video-content video {
      width: 100%;
    }
    .item-info {
      > div {
        margin: 20px 0;
        font-size: 20px;
      }
    }
  }
}
.main .right {
  float: right;
  margin-right: 20px;
  .right-content {
    box-sizing: border-box;
    padding: 20px;
    color: #fff;
    .item-info {
      > div {
        margin: 20px 0;
        font-size: 20px;
      }
    }
  }
}
.left-overflow {
  overflow-y: scroll !important;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
.right-overflow {
  overflow-y: scroll !important;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
::-webkit-scrollbar {
  width: 0px;
}
::v-deep .main .left .left-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .main .right .right-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
  